import EvenOddListSectionProps from '@/v2/components/sections/landing-pages/even-odd-section'
// import FaqSection from '@/v2/components/sections/landing-pages/faq-section'
// import GridSection from '@/v2/components/sections/landing-pages/grid-section'
import HelperGuideSection from '@/v2/components/sections/landing-pages/helper-guide-section'
import HeroSection from '@/v2/components/sections/landing-pages/hero-section'
// import InfoBannerSection from '@/v2/components/sections/landing-pages/info-banner-section'
// import WhyChooseUsSection from '@/v2/components/sections/landing-pages/why-choose-us-section'
import {
  evenOddList,
  // faqSectionContent,
  // gridSectionContent,
  helperGuideSection,
  heroSectionContent
  // infoBannerSectionContent,
  // whyChooseUsSectionContent
} from '@/v2/constants/pages/landing-pages/summer-storage-for-college-students-page'

interface SummerStorageForCollegeStudentsPageProps {}

const SummerStorageForCollegeStudentsPage: React.FC<SummerStorageForCollegeStudentsPageProps> = () => {
  return (
    <>
      <HeroSection {...heroSectionContent} />
      <HelperGuideSection {...helperGuideSection} />
      <EvenOddListSectionProps {...evenOddList} />
      {/* <GridSection
        title={gridSectionContent.title}
        description={gridSectionContent.description}
        cards={gridSectionContent.cards}
      />
      <WhyChooseUsSection
        title={whyChooseUsSectionContent.title}
        description={whyChooseUsSectionContent.description}
        cards={whyChooseUsSectionContent.cards}
      />
      <InfoBannerSection card={infoBannerSectionContent} ctaButton={infoBannerSectionContent.ctaButton} />
      <FaqSection
        title={faqSectionContent.title}
        description={faqSectionContent.description}
        questions={faqSectionContent.questions}
      /> */}
    </>
  )
}

export default SummerStorageForCollegeStudentsPage
